export { Translate as default } from './Translate';
